import { DateWrap, maxTextLines, nameStyle} from 'Shared/frontend/Poster';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';
import { css } from '@emotion/css';
import { For } from 'solid-js';
import { Show } from 'solid-js';
import { genreList } from 'Shared/common/Macros';
import { posterOfType } from 'Shared/frontend/SettingsProvider';


export const commonGenresStyle = () => css({
	textTransform: 'lowercase',
	lineHeight: 2,
	fontSize: '0.7em',
	...maxTextLines(2),

});

export function actImageUrl(image)
{
	if (!image?.hash)
		return '';
	return useUrls().createVenueImageUrl(image.hash,image,'Lineup-image','medium',useProxyProductionImages());
}


export function FallbackMusicPoster(P)
{
	const theme = () => posterOfType('fiveActs');

	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center'
	});

	const eventNameStyle = () => css(nameStyle(), {
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: 18
	});

	return (
		<DateWrap {...P}>
			<div class={posterStyle()}>
				<Show when={P.name}>
					<div class={eventNameStyle()}>{ P.name }</div>
				</Show>

				<For each={P.lineup}>{item =>
					<Artist {...item} fontSize={theme().artistNames.fontSize} />
				}</For>
			</div>
		</DateWrap>
	);
}

function Artist(P)
{
	const artistNameStyle = () => css({
		width: '100%', 
		fontSize: P.fontSize
	});

	const artistStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch'
	});

	const genresStyle = () => css(commonGenresStyle(), {
		fontSize: '0.7em'
	});

//TODO larger fonts for fewer acts 
//TODO add a border

	return (
		<div class={artistStyle()}>
			<Show when={P.name}>
				<div class={artistNameStyle()}>{P.name}</div>
			</Show>
			<Show when={P.mainGenre}>
				<div class={genresStyle()}>{ genreList(P) }</div>
			</Show>
		</div>
	);
}

